/* DSL Wishlist → PDF export (lazy-load jsPDF) */
(function(){
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-wishlist-pdf]")) return;
    e.preventDefault();
    var btn = e.target;
    btn.disabled = true; btn.dataset.orig = btn.textContent; btn.textContent = "PDF maken...";
    var s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    s.onload = function(){
      var ids = window.DSL_WISHLIST ? [...window.DSL_WISHLIST.get()] : [];
      var doc = new window.jspdf.jsPDF();
      doc.setFontSize(18); doc.text("Mijn DSL Wishlist", 14, 20);
      doc.setFontSize(10);
      ids.forEach(function(handle, i){ doc.text("• " + handle, 14, 35 + (i * 8)); });
      doc.save("dsl-wishlist.pdf");
      btn.disabled = false; btn.textContent = btn.dataset.orig;
      if (window.DSL_AB) window.DSL_AB.track("wishlist_pdf", {count: ids.length});
    };
    document.head.appendChild(s);
  });
})();